/* eslint-disable no-bitwise */
import React, { useEffect, useState } from 'react';

const uuidv5 = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });

const RelatedStories = () => {
  const [cnxpsLoaded, setCnxpsLoaded] = useState(false);
  const [randomId, setRandomId] = useState(null);

  useEffect(() => {
    // set randomId for Connatix to render into
    setRandomId(uuidv5());

    if (window.cnxps) {
      setCnxpsLoaded(true);
    } else {
      // Listen for the Connatix object to be added to window
      const intervalId = setInterval(() => {
        if (window.cnxps) {
          clearInterval(intervalId);
          setCnxpsLoaded(true);
        }
      }, 200);
    }
  }, []);

  useEffect(
    () => {
      if (!cnxpsLoaded || !randomId) return;
      window.cnxps.cmd.push(() => {
        window
          .cnxps({
            playerId: '86fd0e84-5f99-4f4b-8281-4147bb00e49a'
          })
          .render(randomId);
      });
    },
    [cnxpsLoaded]
  );

  if (!cnxpsLoaded || !randomId) return null;

  return (
    <section className="finite-scroll__related-stories">
      <div className="finite-scroll__header">More Top Stories:</div>
      {randomId && <script id={randomId} async />}
      <div className="cnx-finite-scroll-connatix" />
    </section>
  );
};

export default RelatedStories;
